<template>
  <div id="pers-tab9" name="hres31x-tab9" class="content-pers" :class="{'-fixed-height-box' : pcDisp}">

    <!--Start Topic #1-->
    <div class="sub-topic-box color-skin" @click="toggleSubTopic1">
      <i class="fa fa-user icon-sub-topic" aria-hidden="true"></i>
      <div class="sub-topic">{{ labels['HRES31XC9']['10'] }}</div>
    </div>

    <div class="data-pers-box" v-show="subTopic1">
      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC9']['30'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['namspous'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC9']['40'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['numoffid'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC9']['50'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['codspocc'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC9']['60'] }}</div>
        <div class="col-xs-6 data-text">{{ setDateOutput(detail['dtespbd']) }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC9']['70'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['desnoffi'] }}</div>
      </div>
    </div>
    <!--End Topic #1-->
    <!--Start Topic #2-->
    <div class="sub-topic-box color-skin" @click="toggleSubTopic2">
      <i class="fa fa-file-text icon-sub-topic" aria-hidden="true"></i>
      <div class="sub-topic">{{ labels['HRES31XC9']['80'] }}</div>
    </div>

    <div class="data-pers-box" v-show="subTopic2">
      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC9']['90'] }}</div>
        <div class="col-xs-6 data-text">{{ setDateOutput(detail['dtemarry']) }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC9']['100'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['codsppro'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC9']['110'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['codspcty'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC9']['120'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['desplreg'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC9']['130'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['desnote'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC9']['160'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['idf'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC9']['170'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['idm'] }}</div>
      </div>
    </div>
    <!--End Topic #2-->
    
  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hres31x-tab9',
  data () {
    return {
      subTopic1: true,
      subTopic2: true
    }
  },
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    },
    toggleSubTopic1 () {
      this.subTopic1 = !this.subTopic1
    },
    toggleSubTopic2 () {
      this.subTopic2 = !this.subTopic2
    }
  },
  props: [ 'nowLang', 'labels', 'detail', 'pcDisp', 'togglePage', 'triggerButton' ]
}
</script>


// WEBPACK FOOTER //
// tab9.vue?2aab7f30